import { useResizeObserver } from "@smartsheet/lodestar-utils";
import { useCallback, useState } from "react";
export const useHorizontalResize = function () {
  let {
    initialWidth = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [width, setWidth] = useState(initialWidth);
  const {
    ref
  } = useResizeObserver(useCallback(entry => {
    const newHorizontalSize = entry[0].borderBoxSize[0].inlineSize;
    if (newHorizontalSize) {
      setWidth(newHorizontalSize);
    }
  }, []));
  return {
    ref,
    width
  };
};
//# sourceMappingURL=useHorizontalResize.js.map